import { BaseProvider } from "./base.provider";

export interface SendNotificationPayload {
  action_type: string;
  body: string;
  redirect_path: string;
  actor_user_id?: string | null;
  icon_obj_path?: string | null;
}

export interface SendLocationNotificationPayload extends SendNotificationPayload {
  lat: number;
  lng: number;
  radius_meters: number;
}

export interface Notification {
  notification_id: string;
  recipient_user_id: string;
  actor_user_id: string | null;
  action_type: string;
  body: string;
  icon_url: string | null;
  is_read: boolean;
  read_at: string | null;
  redirect_path: string;
  channel_key: string;
  created_at: string;
}

class NotificationsProvider extends BaseProvider {
  list(unreadOnly?: boolean): Promise<Notification[]> {
    const qs = unreadOnly ? "?unread=true" : "";
    return this.request<Notification[]>(`/v1/users/notifications${qs}`);
  }

  markRead(id: string | "all"): Promise<void> {
    return this.request<void>(`/v1/users/notifications/${id}/read`, {
      method: "PATCH",
    });
  }

  sendToUser(userId: string, payload: SendNotificationPayload): Promise<void> {
    return this.request<void>(
      `/v1/admin/users/${encodeURIComponent(userId)}/notifications`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
    );
  }

  sendToLocation(payload: SendLocationNotificationPayload): Promise<void> {
    return this.request<void>("/v1/admin/notifications/location", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}

export const notificationsProvider = new NotificationsProvider();
